import { homeOutline, mapOutline, storefrontOutline } from 'ionicons/icons';

/**
 * Router tabs for the SU shell (Home, State, Stores). "More" is not a route: it opens a sheet, see MoreTabButton in
 * routes/SuRoutes.tsx. NOTE: the IonTabBar itself is rendered inline there because IonTabs only recognises IonTabBar
 * as a direct child (not a wrapper component).
 */
export const SU_TABS = [
  { tab: 'home', label: 'Home', href: '/app/home', icon: homeOutline },
  { tab: 'states', label: 'State', href: '/app/states', icon: mapOutline },
  { tab: 'stores', label: 'Stores', href: '/app/stores', icon: storefrontOutline },
];
